/* My Essenza — envio de avaliações para o nosso serviço. 22/09/2026.
   O widget desenha-se todo sem JavaScript; isto serve só para enviar o formulário sem
   recarregar a página. Se o JavaScript falhar, o formulário continua a submeter-se
   normalmente para o serviço (action/method preenchidos aqui em baixo). */
(function () {
  'use strict';

  function ligar(form) {
    var url = form.getAttribute('data-me-resenhas');
    if (!url || form.meLigado) return;   /* me-fotos-2309: script incluído 2× → não ligar 2× */
    form.meLigado = true;
    form.action = url;
    form.method = 'post';

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var botao = form.querySelector('button[type=submit]');
      if (botao) { botao.disabled = true; }
      form.classList.remove('is-erro');

      var d = new FormData(form);
      var corpo = {
        produto_id: form.getAttribute('data-produto'),
        handle: form.getAttribute('data-handle'),
        lingua: form.getAttribute('data-lingua') || '',
        nota: parseInt(d.get('r') || '0', 10),
        nome: (d.get('n') || '').toString().trim(),
        email: (d.get('e') || '').toString().trim(),
        titulo: (d.get('t') || '').toString().trim(),
        texto: (d.get('b') || '').toString().trim(),
        armadilha: (d.get('w') || '').toString(),
        pagina: location.pathname
      };

      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(corpo)
      }).then(function (r) {
        if (!r.ok) throw new Error('http ' + r.status);
        return r.json();
      }).then(function () {
        form.classList.add('is-ok');
      }).catch(function () {
        form.classList.add('is-erro');
        if (botao) { botao.disabled = false; }
      });
    });
  }

  function arrancar() {
    var fs = document.querySelectorAll('form[data-me-resenhas]');
    for (var i = 0; i < fs.length; i++) ligar(fs[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
  /* o tema troca secções sem recarregar a página (Horizon) */
  document.addEventListener('shopify:section:load', arrancar);
})();

/* me-fotos-2309 — visualizador leve das fotos das avaliações. Sem JavaScript cada miniatura é
   uma ligação normal para a foto grande. Com ele: <dialog> modal (foco preso pelo browser,
   Esc fecha), setas ←/→, e o foco volta à miniatura de onde se veio. Carrega a foto grande só
   quando se abre. */
(function () {
  'use strict';
  /* o tema inclui me-resenhas.js duas vezes: sem esta guarda abriam-se dois visualizadores */
  if (window.meResFotos) return;
  window.meResFotos = true;
  var lb, img, cont, grupo = [], pos = 0, origem = null;

  function rotulo(el, nome, def) {
    var s = el && el.closest('.me-res');
    return (s && s.getAttribute('data-me-' + nome)) || def;
  }

  function criar(el) {
    lb = document.createElement('dialog');
    lb.className = 'me-res-lb';
    lb.setAttribute('aria-label', rotulo(el, 'titulo-fotos', 'Fotos'));
    lb.innerHTML = '<figure class="me-res-lb__fig"><img class="me-res-lb__img" alt=""></figure>' +
      '<button type="button" class="me-res-lb__btn me-res-lb__fechar">\u00d7</button>' +
      '<button type="button" class="me-res-lb__btn me-res-lb__ant">\u2039</button>' +
      '<button type="button" class="me-res-lb__btn me-res-lb__seg">\u203a</button>' +
      '<p class="me-res-lb__cont" aria-live="polite"></p>';
    document.body.appendChild(lb);
    img = lb.querySelector('.me-res-lb__img');
    cont = lb.querySelector('.me-res-lb__cont');
    lb.querySelector('.me-res-lb__fechar').addEventListener('click', fechar);
    lb.querySelector('.me-res-lb__ant').addEventListener('click', function () { ir(-1); });
    lb.querySelector('.me-res-lb__seg').addEventListener('click', function () { ir(1); });
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.tagName === 'FIGURE') fechar(); });
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { ir(-1); e.preventDefault(); }
      if (e.key === 'ArrowRight') { ir(1); e.preventDefault(); }
    });
    lb.addEventListener('close', function () {
      img.removeAttribute('src');
      if (origem) { origem.focus(); origem = null; }
    });
  }

  function mostrar() {
    img.src = grupo[pos].getAttribute('href');
    cont.textContent = (pos + 1) + ' / ' + grupo.length;
  }
  function ir(d) { pos = (pos + d + grupo.length) % grupo.length; mostrar(); }
  function fechar() { if (lb && lb.open) lb.close(); }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-me-foto]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    if (typeof HTMLDialogElement !== 'function') return;     /* browser antigo: segue a ligação */
    e.preventDefault();
    if (!lb) criar(a);
    lb.querySelector('.me-res-lb__fechar').setAttribute('aria-label', rotulo(a, 'fechar', 'Fechar'));
    lb.querySelector('.me-res-lb__ant').setAttribute('aria-label', rotulo(a, 'anterior', 'Anterior'));
    lb.querySelector('.me-res-lb__seg').setAttribute('aria-label', rotulo(a, 'seguinte', 'Seguinte'));
    var g = a.closest('[data-me-fotos-grupo]');
    grupo = Array.prototype.slice.call((g || a.parentNode).querySelectorAll('a[data-me-foto]'));
    pos = Math.max(0, grupo.indexOf(a));
    origem = a;
    if (grupo.length < 2) lb.setAttribute('data-uma', ''); else lb.removeAttribute('data-uma');
    mostrar();
    lb.showModal();
    lb.querySelector('.me-res-lb__fechar').focus();
  });
})();
